<div class="scholarship-hero-wrapper w-full relative" style="margin-top: -32px; overflow: hidden; padding-bottom: 0;">
  <!-- Dark Blue Background with Arc -->
  <div class="scholarship-hero-bg w-full relative flex justify-content-center">
    
    <!-- Paper Plane Image -->
    <img src="assets/images/Scholarship-plan.png" class="hero-plane hidden md:block" alt="Paper Plane" style="position: absolute; top:-5%; left: -5%; pointer-events: none; width: 500px; height: auto;" />

    <!-- Content Container -->
    <div class="container_width flex flex-column md:flex-row align-items-center justify-content-between h-full relative py-6">
      
      <!-- Text Side -->
      <div class="flex flex-column text-center w-full relative" style="max-width: 800px; margin: 0 auto; padding-top: 50px; padding-bottom: 70px;">
        
        <!-- Sparkles SVG near text -->
        <svg class="hero-sparkles hidden md:block" width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 20px; right: -20px; pointer-events: none;">
          <path d="M35 0 L39 25 L65 30 L39 35 L35 60 L31 35 L5 30 L31 25 Z" fill="#ffffff" />
          <path d="M50 45 L52 52 L60 54 L52 56 L50 64 L48 56 L40 54 L48 52 Z" fill="#ffffff" />
        </svg>

        <h1 class="font-bold mb-4 mt-0 line-height-2" style="color: #d3de32; font-size: clamp(2rem, 5vw, 3.8rem); font-family: 'Circular Std', sans-serif;">
          Unlock Your Dream <br/> University Scholarship
        </h1>
        <p class="text-white mb-5 mx-auto" style="font-size: 16px; font-weight: 400; max-width: 520px; line-height: 1.6; font-family: 'Karla', sans-serif; opacity: 0.95;">
          Browse and apply to hundreds of scholarships across 800+ universities worldwide — filtered by your profile, programme, and destination — all in one place.
        </p>
        
        <div class="flex justify-content-center">
          <button (click)="scrollToScholarshipFinder()" class="font-bold border-none cursor-pointer transition-colors" 
                  style="background: #d3de32; color: #110a9d; padding: 16px 36px; border-radius: 8px; font-size: 16px; font-family: 'Circular Std', sans-serif; box-shadow: 0 4px 12px rgba(211, 222, 50, 0.3);"
                  onmouseover="this.style.background='#c1cb2a'" onmouseout="this.style.background='#d3de32'">
            Explore Scholarships
          </button>
        </div>
      </div>
      
    </div>

    <!-- Graduate Image -->
    <div class="hero-graduate-img-container hidden lg:block" style="position: absolute; bottom: 0px; right: 0px; height: 70%; z-index: 1;">
      <img src="assets/images/ScholarWomen.png" alt="Scholarship Graduate" style="height: 100%; object-fit: contain; object-position: bottom right;" />
    </div>

  </div>

  <!-- University Logos Section -->
  <app-university-logos-marquee></app-university-logos-marquee>
</div>

<section class="container_width py-8 overflow-hidden">
  <div class="flex justify-content-center mb-6">
    <h2 class="font-bold text-4xl m-0 text-center relative" style="color: #0b117b; font-family: 'Circular Std', sans-serif; display: inline-block;">
      Why <span class="relative" style="font-family: inherit; font-weight: inherit;">Trust us ?<div style="position: absolute; bottom: -8px; left: 5%; width: 90%; height: 4px; background-color: #d3de32;"></div></span>
    </h2>
  </div>

  <div class="trust-cards-container flex flex-column gap-4 justify-content-center mt-5 mx-auto" style="max-width: 1100px;">
    
    <!-- Top Row (Card 1 & 2) -->
    <div class="trust-row-1 flex flex-column md:flex-row justify-content-center gap-4 w-full animate-fade-in">
      <!-- Card 1 -->
      <div class="feature-card p-4 border-round-2xl flex">
        <div class="icon-container flex-shrink-0 flex align-items-center justify-content-center border-round-xl mr-4" style="background-color: #0b117b; width: 64px; height: 64px;">
          <!-- Speed Clock SVG -->
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 10H10" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M2 16H8" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M5 22H9" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round"/>
            <circle cx="20" cy="16" r="9" stroke="#d3de32" stroke-width="2.5"/>
            <path d="M20 11V16H24" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="flex flex-column">
          <h3 class="font-bold text-lg mb-3 mt-1" style="color: #0f172a; font-family: 'Circular Std', sans-serif;">Up-to-date listings</h3>
          <p class="text-gray-600 line-height-3 m-0" style="font-size: 14.5px;">We continuously update our scholarship database so you're never working with outdated deadlines or closed opportunities.</p>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="feature-card p-4 border-round-2xl flex">
        <div class="icon-container flex-shrink-0 flex align-items-center justify-content-center border-round-xl mr-4" style="background-color: #0b117b; width: 64px; height: 64px;">
          <!-- Folder Lock SVG -->
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 24V10C6 8.9 6.9 8 8 8H14L16 10H24C25.1 10 26 10.9 26 12V24C26 25.1 25.1 26 24 26H8C6.9 26 6 25.1 6 24Z" stroke="#d3de32" stroke-width="2.5" stroke-linejoin="round"/>
            <path d="M17 17V15.5C17 14.1 18.1 13 19.5 13C20.9 13 22 14.1 22 15.5V17" stroke="#d3de32" stroke-width="2" stroke-linecap="round"/>
            <rect x="15" y="17" width="9" height="6" rx="1.5" fill="#d3de32"/>
          </svg>
        </div>
        <div class="flex flex-column">
          <h3 class="font-bold text-lg mb-3 mt-1" style="color: #0f172a; font-family: 'Circular Std', sans-serif;">Verified opportunities only</h3>
          <p class="text-gray-600 line-height-3 m-0" style="font-size: 14.5px;">Every scholarship on our platform is manually verified. No scams, no dead links, just real funding from real institutions.</p>
        </div>
      </div>
    </div>

    <!-- Bottom Row (Card 3 & 4) -->
    <div class="trust-row-2 flex flex-column md:flex-row justify-content-center gap-4 w-full animate-fade-in">
      <!-- Card 3 -->
      <div class="feature-card p-4 border-round-2xl flex">
        <div class="icon-container flex-shrink-0 flex align-items-center justify-content-center border-round-xl mr-4" style="background-color: #0b117b; width: 64px; height: 64px;">
          <!-- Calendar SVG -->
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="6" y="8" width="20" height="18" rx="3" stroke="#d3de32" stroke-width="2.5" stroke-linejoin="round"/>
            <path d="M11 5V9" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M21 5V9" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round"/>
            <path d="M6 14H26" stroke="#d3de32" stroke-width="2.5"/>
            <circle cx="11" cy="19" r="1.5" fill="#d3de32"/>
            <circle cx="16" cy="19" r="1.5" fill="#d3de32"/>
            <circle cx="21" cy="19" r="1.5" fill="#d3de32"/>
          </svg>
        </div>
        <div class="flex flex-column">
          <h3 class="font-bold text-lg mb-3 mt-1" style="color: #0f172a; font-family: 'Circular Std', sans-serif;">Never Miss a Deadline</h3>
          <p class="text-gray-600 line-height-3 m-0" style="font-size: 14.5px;">Our scholarship calendar tracks closing dates by month and day, so you always know what's coming up and have time to prepare.</p>
        </div>
      </div>

      <!-- Card 4 -->
      <div class="feature-card p-4 border-round-2xl flex">
        <div class="icon-container flex-shrink-0 flex align-items-center justify-content-center border-round-xl mr-4" style="background-color: #0b117b; width: 64px; height: 64px;">
          <!-- Headset SVG -->
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 18C7 12 11 8 16 8C21 8 25 12 25 18" stroke="#d3de32" stroke-width="2.5" stroke-linecap="round"/>
            <rect x="4" y="16" width="5" height="9" rx="2.5" fill="#d3de32"/>
            <rect x="23" y="16" width="5" height="9" rx="2.5" fill="#d3de32"/>
            <path d="M9 20H7M23 20H25" stroke="#0b117b" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="flex flex-column">
          <h3 class="font-bold text-lg mb-3 mt-1" style="color: #0f172a; font-family: 'Circular Std', sans-serif;">Peer & Mentor Support</h3>
          <p class="text-gray-600 line-height-3 m-0" style="font-size: 14.5px;">Have questions about a scholarship? Book a session with a peer who's been around the block or a mentor who's guided students through it.</p>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- How it works Section -->
<section class="how-it-works-section w-full py-8" style="background-color: #f6f7fc;">
  <div class="container_width">
    <!-- Title -->
    <div class="flex justify-content-center mb-8">
      <h2 class="font-bold text-4xl m-0 text-center relative" style="color: #0b117b; font-family: 'Circular Std', sans-serif; display: inline-block;">
        How it <span class="relative" style="font-family: inherit; font-weight: inherit;">Works<div style="position: absolute; bottom: -8px; left: 0; width: 100%; height: 4px; background-color: #d3de32;"></div></span> - 4 Easy Steps
      </h2>
    </div>

    <!-- Timeline Wrapper -->
    <div class="timeline-container relative mx-auto" style="max-width: 1050px;">
      
      <!-- Connecting Line -->
      <div class="connecting-line"></div>

      <!-- Steps Grid -->
      <div class="timeline-steps-wrapper flex justify-content-between relative z-2">
        
        <!-- Step 1 -->
        <div class="step-item flex flex-column align-items-center text-center">
          <div class="icon-box bg-dark shadow-dark flex align-items-center justify-content-center border-round-2xl mb-4" style="width: 84px; height: 84px;">
            <i class="pi pi-filter text-4xl text-white"></i>
          </div>
          <span class="text-xs font-bold text-gray-500 mb-2 uppercase" style="letter-spacing: 1px;">Step 1</span>
          <h4 class="font-bold m-0 mb-2" style="color: #0b117b; font-size: 16px;">Search & Filter</h4>
          <p class="text-gray-500 m-0 line-height-3" style="font-size: 13.5px;">Set your country, degree level, and funding type to find scholarships you qualify for.</p>
        </div>

        <!-- Step 2 -->
        <div class="step-item flex flex-column align-items-center text-center">
          <div class="icon-box bg-yellow shadow-yellow flex align-items-center justify-content-center border-round-2xl mb-4" style="width: 84px; height: 84px;">
            <i class="pi pi-calendar text-4xl text-white"></i>
          </div>
          <span class="text-xs font-bold text-gray-500 mb-2 uppercase" style="letter-spacing: 1px;">Step 2</span>
          <h4 class="font-bold m-0 mb-2" style="color: #0b117b; font-size: 16px;">Check Deadlines</h4>
          <p class="text-gray-500 m-0 line-height-3" style="font-size: 13.5px;">Browse our deadline calendar to see exactly when each scholarship closes, by month or by day.</p>
        </div>
        
        <!-- Step 3 -->
        <div class="step-item flex flex-column align-items-center text-center">
          <div class="icon-box bg-dark shadow-dark flex align-items-center justify-content-center border-round-2xl mb-4" style="width: 84px; height: 84px;">
            <i class="pi pi-users text-4xl text-white"></i>
          </div>
          <span class="text-xs font-bold text-gray-500 mb-2 uppercase" style="letter-spacing: 1px;">Step 3</span>
          <h4 class="font-bold m-0 mb-2" style="color: #0b117b; font-size: 16px;">Book a Session</h4>
          <p class="text-gray-500 m-0 line-height-3" style="font-size: 13.5px;">Connect with a peer who's been through the process or a mentor who's guided students through the process.</p>
        </div>

        <!-- Step 4 -->
        <div class="step-item flex flex-column align-items-center text-center">
          <div class="icon-box bg-yellow shadow-yellow flex align-items-center justify-content-center border-round-2xl mb-4" style="width: 84px; height: 84px;">
            <i class="pi pi-send text-4xl text-white"></i>
          </div>
          <span class="text-xs font-bold text-gray-500 mb-2 uppercase" style="letter-spacing: 1px;">Step 4</span>
          <h4 class="font-bold m-0 mb-2" style="color: #0b117b; font-size: 16px;">Apply with Confidence</h4>
          <p class="text-gray-500 m-0 line-height-3" style="font-size: 13.5px;">Head into your application knowing exactly what's expected and when it's due.</p>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- Scholarship Finder Map Section -->
<section id="scholarship-finder" class="scholarship-finder-section w-full py-8">
  <div class="container_width" style="max-width: 1400px;">
    <!-- Header with Toggle -->
    <div class="flex justify-content-between align-items-center mb-6 flex-column md:flex-row gap-4">
      <div class="flex-1 hidden md:block"></div>
      
      <h2 class="font-bold text-5xl m-0 text-center relative flex-1" style="color: #0b117b; font-family: 'Circular Std', sans-serif; white-space: nowrap;">
        {{ activeView === 'map' ? 'Scholarship Finder' : 'Deadline Calendar' }}
        <div style="position: absolute; bottom: -8px; left: 20%; width: 60%; height: 5px; background-color: #d3de32;"></div>
      </h2>
      
      <div class="flex-1 flex justify-content-end w-full md:w-auto">
        <div class="flex border-round-lg bg-white overflow-hidden shadow-1" style="border: 1px solid #e2e8f0;">
          <button class="p-link px-4 py-2 font-bold text-sm transition-colors"
                  [style.background-color]="activeView === 'map' ? '#0b117b' : 'transparent'"
                  [style.color]="activeView === 'map' ? 'white' : '#1e293b'"
                  (click)="setView('map')">
            Scholarship Finder
          </button>
          <button class="p-link px-4 py-2 font-bold text-sm transition-colors"
                  [style.background-color]="activeView === 'calendar' ? '#0b117b' : 'transparent'"
                  [style.color]="activeView === 'calendar' ? 'white' : '#1e293b'"
                  (click)="setView('calendar')">
            Deadlines
          </button>
        </div>
      </div>
    </div>

    <!-- Main Grid: Sidebar + Map -->
    <div class="grid mt-6" [style.display]="activeView === 'map' ? 'flex' : 'none'">
      <!-- Left Sidebar: Filters -->
      <div class="col-12 md:col-4 lg:col-3">
        <div class="filter-sidebar bg-white border-round-2xl p-4 shadow-1 h-full" style="border: 1px solid #f1f5f9;">
          <h3 class="font-bold text-2xl m-0 mb-5" style="color: #000; font-family: 'Circular Std', sans-serif;">Filter</h3>
          
          <!-- Location Filter -->
          <div class="filter-group mb-5">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> LOCATION
            </h5>
            <p-dropdown [options]="locations" [(ngModel)]="selectedLocation" optionLabel="name" placeholder="Search Location" styleClass="w-full custom-dropdown"></p-dropdown>
          </div>

          <!-- Degree Level -->
          <div class="filter-group mb-5">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> DEGREE LEVEL
            </h5>
            <div class="flex flex-wrap gap-2">
              <button class="p-link pill-btn" [class.active]="degreeLevel === 'All'" (click)="setDegreeLevel('All')">All</button>
              <button class="p-link pill-btn" [class.active]="degreeLevel === 'Under Graduate'" (click)="setDegreeLevel('Under Graduate')">Under Graduate</button>
              <button class="p-link pill-btn" [class.active]="degreeLevel === 'Post Graduate'" (click)="setDegreeLevel('Post Graduate')">Post Graduate</button>
              <button class="p-link pill-btn" [class.active]="degreeLevel === 'PHD'" (click)="setDegreeLevel('PHD')">PHD</button>
            </div>
          </div>

          <!-- Academic Eligibility -->
          <div class="filter-group mb-5">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> ACADEMIC ELIGIBILITY ({{ eligibilityRange }}%)
            </h5>
            <div class="px-2 mt-5 mb-2">
              <p-slider [(ngModel)]="eligibilityRange" [min]="0" [max]="100" styleClass="custom-slider"></p-slider>
            </div>
            <div class="flex justify-content-between text-xs font-bold text-gray-800">
              <span>0</span>
              <span style="color: #0b117b; font-weight: 800;">{{ eligibilityRange }}%</span>
              <span>100%</span>
            </div>
          </div>

          <!-- Funding Type -->
          <div class="filter-group mb-2">
            <h5 class="text-xs font-bold uppercase m-0 mb-3 flex align-items-center gap-2" style="color: #0b117b; letter-spacing: 0.5px;">
              <span style="width: 3px; height: 14px; background: #d3de32; display: inline-block;"></span> FUNDING TYPE
            </h5>
            <div class="flex flex-wrap gap-2">
              <button class="p-link pill-btn" [class.active]="fundingType === 'All'" (click)="setFundingType('All')">All</button>
              <button class="p-link pill-btn" [class.active]="fundingType === 'Tuition'" (click)="setFundingType('Tuition')">Tuition</button>
              <button class="p-link pill-btn" [class.active]="fundingType === 'Living'" (click)="setFundingType('Living')">Living</button>
              <button class="p-link pill-btn" [class.active]="fundingType === 'Loan Scholarship'" (click)="setFundingType('Loan Scholarship')">Loan Scholarship</button>
              <button class="p-link pill-btn" [class.active]="fundingType === 'Stipend'" (click)="setFundingType('Stipend')">Stipend</button>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex gap-2 mt-5 pt-3" style="border-top: 1px solid #f1f5f9;">
            <button class="p-link reset-btn flex-1 py-3 border-round-xl font-bold text-center transition-colors text-sm"
                    style="border: 1px solid #e2e8f0; color: #475569; background: #ffffff; cursor: pointer;"
                    onmouseover="this.style.background='#f8fafc'"
                    onmouseout="this.style.background='#ffffff'"
                    (click)="resetFilters()">
              Reset
            </button>
            <button class="p-link apply-btn flex-1 py-3 border-round-xl font-bold text-center transition-colors text-sm text-white"
                    style="background: #0b117b; border: none; cursor: pointer;"
                    onmouseover="this.style.background='#1e293b'"
                    onmouseout="this.style.background='#0b117b'"
                    (click)="applyFilters()">
              Apply
            </button>
          </div>
        </div>
      </div>

      <!-- Right Area: Map -->
      <div class="col-12 md:col-8 lg:col-9">
        <div class="map-wrapper w-full h-full relative overflow-hidden" style="min-height: 600px; background-color: #ffffff;">
          
          <div *ngIf="isLoading" class="absolute top-0 left-0 w-full h-full flex justify-content-center align-items-center bg-white" style="z-index: 1000;">
            <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #0b117b;"></i>
          </div>

          <!-- Leaflet Map -->
          <div class="h-full w-full"
               leaflet
               [leafletOptions]="mapOptions"
               [leafletLayers]="layers"
               (leafletMapReady)="onMapReady($event)">
          </div>

        </div>
      </div>
    </div>

    <!-- Calendar View Grid: Sidebar + Calendar Grid -->
    <div class="grid mt-6 calendar-view-container" *ngIf="activeView === 'calendar'">
      <!-- Left Column: Upcoming deadlines sidebar -->
      <div class="col-12 md:col-4">
        <div class="upcoming-deadlines-sidebar border-round-3xl p-5 shadow-2 flex flex-column h-full">
          <h3 class="font-bold text-2xl mb-4 mt-2 text-left" style="color: #0b117b; font-family: 'Circular Std', sans-serif; line-height: 1.3;">
            <ng-container *ngIf="!selectedDate">
              Upcoming deadlines in {{ months[currentMonthIndex] }}
            </ng-container>
            <ng-container *ngIf="selectedDate">
              Deadlines on {{ months[selectedDate.getMonth()] }} {{ selectedDate.getDate() }}
            </ng-container>
          </h3>
          <div class="deadline-cards-scroll flex-grow-1 overflow-y-auto pr-1" style="max-height: 520px;">
            <div *ngIf="upcomingDeadlines.length === 0" class="no-deadlines-msg p-4 text-center border-round-2xl text-sm" style="background: rgba(255, 255, 255, 0.3); color: #0b117b;">
              No deadlines this month
            </div>
            <div *ngFor="let s of upcomingDeadlines"
                 class="upcoming-deadline-card p-4 mb-3 border-round-2xl cursor-pointer transition-all"
                 (click)="openScholarshipDetails(s)">
              <span class="font-bold text-md" style="color: #0b117b; font-family: 'Circular Std', sans-serif;">{{ s.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column: Calendar Grid -->
      <div class="col-12 md:col-8">
        <div class="calendar-main-card bg-white border-round-3xl p-5 shadow-1 flex flex-column h-full" style="border: 1px solid #f1f5f9;">
          <!-- Calendar Navigator -->
          <div class="flex justify-content-center align-items-center gap-4 mb-5">
            <!-- Prev Arrow -->
            <button class="nav-arrow-btn border-circle flex align-items-center justify-content-center cursor-pointer transition-colors"
                    (click)="prevMonth()">
              <i class="pi pi-chevron-left" style="color: white; font-size: 14px;"></i>
            </button>
            
            <!-- Month and Year Bubble -->
            <div class="flex flex-column align-items-center">
              <div class="month-bubble font-bold px-6 py-3 border-round-full text-center shadow-1 cursor-pointer transition-transform hover:scale-105 active:scale-95"
                   style="background-color: #0b117b; color: white; font-size: 20px; font-family: 'Circular Std', sans-serif; min-width: 180px; user-select: none;"
                   (click)="clearSelectedDate()">
                {{ months[currentMonthIndex] }}
              </div>
              <div class="year-badge font-bold px-3 py-1 border-round-full mt-2 shadow-sm text-xs"
                   style="background-color: #cddb29; color: #000; font-family: 'Circular Std', sans-serif;">
                {{ currentYear }}
              </div>
            </div>

            <!-- Next Arrow -->
            <button class="nav-arrow-btn border-circle flex align-items-center justify-content-center cursor-pointer transition-colors"
                    (click)="nextMonth()">
              <i class="pi pi-chevron-right" style="color: white; font-size: 14px;"></i>
            </button>
          </div>

          <!-- Weekdays Header Row -->
          <div class="weekdays-grid grid text-center font-bold mb-3" style="color: #0b117b; font-family: 'Circular Std', sans-serif; font-size: 15px;">
            <div class="col">Mon</div>
            <div class="col">Tue</div>
            <div class="col">Wed</div>
            <div class="col">Thu</div>
            <div class="col">Fri</div>
            <div class="col">Sat</div>
            <div class="col">Sun</div>
          </div>

          <!-- Days Grid -->
          <div class="days-grid-layout">
            <div *ngFor="let day of calendarDays" 
                 class="calendar-day-cell flex flex-column justify-content-between p-3 relative"
                 [class.other-month]="!day.isCurrentMonth"
                 [class.has-events]="day.scholarships && day.scholarships.length > 0"
                 [class.selected-day]="isDateSelected(day.date)"
                 (click)="selectDate(day)">
              
              <!-- Day Number -->
              <div class="day-number font-bold text-lg mb-2" [style.color]="day.isCurrentMonth ? '#000' : '#b1b5c4'">
                {{ day.dayNumber }}
              </div>

              <!-- Day Events/Tags -->
              <div class="day-tags-container flex flex-column gap-1 overflow-hidden">
                <div *ngIf="day.scholarships && day.scholarships.length > 0" 
                     class="event-tag px-2 py-1 border-round text-xs truncate shadow-sm text-center font-bold"
                     style="background-color: #e0f2fe; color: #0284c7;">
                  {{ day.scholarships[0].name }}
                </div>
                <div *ngIf="day.scholarships.length > 1" 
                     class="event-tag px-2 py-1 border-round text-xs truncate shadow-sm text-center font-bold mt-1"
                     style="background-color: #e0f2fe; color: #0284c7;">
                  {{ day.scholarships[1].name }} <span style="font-weight: 800; color: #0369a1; margin-left: 2px;">+{{ day.scholarships.length - 1 }}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Scholarship Details Dialog overlay -->
<p-dialog [(visible)]="scholarshipDialogVisible" [modal]="true" [showHeader]="false"
  styleClass="scholarship-details-dialog-panel"
  [style]="{width: '850px', 'max-width': '95vw', 'max-height': '90vh', 'border-radius': '24px', 'overflow': 'hidden', 'padding': '0'}"
  [contentStyle]="{'padding': '0'}" (onHide)="closeScholarshipDialog()">

  <div class="w-full flex flex-column" *ngIf="selectedScholarship" style="background-color: white; max-height: 90vh;">
    <!-- Header Section -->
    <div class="dialog-header">
      <!-- Close Button -->
      <button class="dialog-close-btn" (click)="closeScholarshipDialog()">
        <i class="pi pi-times"></i>
      </button>

      <!-- Icon & Title -->
      <div class="dialog-title-container">
        <div class="dialog-icon-box">
          <i class="pi pi-graduation-cap"></i>
        </div>
        <h2 class="dialog-title">
          {{selectedScholarship.name}}
        </h2>
      </div>

      <!-- Pills Row -->
      <div class="dialog-pills-row">
        <!-- Pill 1: Country -->
        <div class="dialog-pill">
          <img *ngIf="getCountryFlag(selectedScholarship.country)" [src]="getCountryFlag(selectedScholarship.country)" class="dialog-pill-flag" />
          <i *ngIf="!getCountryFlag(selectedScholarship.country)" class="pi pi-globe"></i>
          <span>{{getCountryPillName(selectedScholarship.country)}}</span>
        </div>
        <!-- Pill 2: Organization -->
        <div class="dialog-pill">
          <i class="pi pi-home"></i>
          <span>{{selectedScholarship.universityOrOrganisationName || 'Varies'}}</span>
        </div>
        <!-- Pill 3: Deadline -->
        <div class="dialog-pill">
          <i class="pi pi-clock"></i>
          <span>Closes {{getDeadlineDisplay(selectedScholarship.deadLine)}}</span>
        </div>
      </div>
    </div>

    <!-- Scrollable Content Area -->
    <div class="w-full overflow-y-auto overflow-x-hidden" style="flex: 1; background-color: #ffffff;">
      <div class="dialog-body-container">
        <div class="dialog-grid">
          <!-- Left Column: Overview & Eligibility -->
          <div class="dialog-left-col">
            
            <!-- OVERVIEW Section -->
            <div class="dialog-section">
              <span class="dialog-section-title">Overview</span>
              
              <div class="dialog-list">
                <!-- Row 1: Country -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-map-marker"></i>
                    </div>
                    <span>Country</span>
                  </div>
                  <div class="dialog-row-value">
                    <img *ngIf="getCountryFlag(selectedScholarship.country)" [src]="getCountryFlag(selectedScholarship.country)" class="dialog-row-flag" />
                    <span>{{selectedScholarship.country ? getCountryDisplayName(selectedScholarship.country) : 'Global'}}</span>
                  </div>
                </div>

                <!-- Row 2: Organization -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-home"></i>
                    </div>
                    <span>Organization</span>
                  </div>
                  <div class="dialog-row-value text-right-ellipsis" [title]="selectedScholarship.universityOrOrganisationName || 'Varies'">
                    {{selectedScholarship.universityOrOrganisationName || 'Varies'}}
                  </div>
                </div>

                <!-- Row 3: Stream -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-book"></i>
                    </div>
                    <span>Stream</span>
                  </div>
                  <div class="dialog-row-value text-right-ellipsis" [title]="getStreamDisplayName(selectedScholarship.stream)">
                    {{getStreamDisplayName(selectedScholarship.stream)}}
                  </div>
                </div>

                <!-- Row 4: Level -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-graduation-cap"></i>
                    </div>
                    <span>Level</span>
                  </div>
                  <div class="dialog-row-value">
                    {{getLevelDisplayName(selectedScholarship.level)}}
                  </div>
                </div>
              </div>
            </div>

            <!-- ELIGIBILITY Section -->
            <div class="dialog-section">
              <span class="dialog-section-title">Eligibility</span>
              
              <div class="dialog-list">
                <!-- Row 1: Nationality -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-flag"></i>
                    </div>
                    <span>Nationality</span>
                  </div>
                  <div class="dialog-row-value">
                    {{selectedScholarship.eligibility?.nationality || 'Check Eligibility'}}
                  </div>
                </div>

                <!-- Row 2: Academic Requirements -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-file"></i>
                    </div>
                    <span>Academic</span>
                  </div>
                  <div class="dialog-row-value-double">
                    <span class="dialog-val-main">{{getAcademicMainText(selectedScholarship.eligibility?.academicRequirements)}}</span>
                    <span class="dialog-val-sub" *ngIf="getAcademicSubText(selectedScholarship.eligibility?.academicRequirements)">{{getAcademicSubText(selectedScholarship.eligibility?.academicRequirements)}}</span>
                  </div>
                </div>

                <!-- Row 3: Others -->
                <div class="dialog-row">
                  <div class="dialog-row-label">
                    <div class="dialog-row-icon">
                      <i class="pi pi-info-circle"></i>
                    </div>
                    <span>Other</span>
                  </div>
                  <div class="dialog-row-value" [class.no-criteria]="!selectedScholarship.eligibility?.others">
                    {{selectedScholarship.eligibility?.others || 'No additional criteria'}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column: What's Covered (Lime Gradient Box) -->
          <div class="dialog-right-col">
            <span class="dialog-section-title">What's Covered</span>
            
            <div class="gradient-card">
              <!-- Funding Amount row -->
              <div class="card-funding-header">
                <div class="funding-icon-box">
                  <i class="pi pi-search"></i>
                </div>
                <div class="funding-text-box">
                  <span class="funding-label">Funding</span>
                  <span class="funding-value">{{getFormattedAmount(selectedScholarship)}}</span>
                </div>
              </div>

              <!-- Coverage checklist items -->
              <div class="card-checklist">
                <div class="checklist-item" [class.not-covered]="!isCovered('tuition')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Tuition covered</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('living')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Living expenses</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('travel')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Travel cost</span>
                </div>
                <div class="checklist-item" [class.not-covered]="!isCovered('health')">
                  <div class="check-circle">
                    <i class="pi pi-check"></i>
                  </div>
                  <span>Health insurance</span>
                </div>
              </div>

              <!-- Dotted Divider -->
              <div class="card-divider"></div>

              <!-- Coverage type row -->
              <div class="card-coverage-footer">
                <span class="coverage-label">Coverage type</span>
                <div class="coverage-pill">
                  {{ getCoverageType() }}
                </div>
              </div>
            </div>
            
            <!-- Illustration below the card -->
            <div class="dialog-illustration-box" style="display: flex; justify-content: center; margin-top: 16px; padding-top: 8px;">
              <img src="assets/images/Group 43057.png" alt="What's Covered Illustration" style="max-width: 100%; height: auto; max-height: 180px; display: block;" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer buttons section -->
    <div class="dialog-footer">
      <!-- Left side: Deadline and link -->
      <div class="dialog-footer-left">
        <!-- Deadline badge -->
        <div class="dialog-deadline-badge">
          <div class="deadline-icon-box">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <div class="deadline-text-box">
            <span class="deadline-label">Deadline</span>
            <span class="deadline-value">
              {{getDeadlineDisplay(selectedScholarship.deadLine)}}
            </span>
          </div>
        </div>

        <!-- Application Link -->
        <a [href]="selectedScholarship.applicationLink" target="_blank"
           class="dialog-app-link"
           *ngIf="selectedScholarship.applicationLink">
          Application Link <i class="pi pi-arrow-up-right"></i>
        </a>
      </div>

      <!-- Right side: Save and Share buttons -->
      <div class="dialog-footer-right">
        <!-- Save bookmark button (heart style) -->
        <button (click)="toggleMyScholarship(selectedScholarship.id)" class="dialog-bookmark-btn" [style.color]="selectedScholarship.isMyScholarship ? '#ef4444' : '#94a3b8'">
          <i class="pi" [ngClass]="selectedScholarship.isMyScholarship ? 'pi-heart-fill' : 'pi-heart'"></i>
        </button>

        <!-- Share with mentor button -->
        <button (click)="shareMenu.toggle($event)" class="dialog-share-btn">
          Share with mentor
        </button>
      </div>

      <!-- Mentor Share overlay panel inside the footer -->
      <p-overlayPanel #shareMenu [showCloseIcon]="false">
        <div class="flex flex-column gap-2 p-1" style="min-width: 200px;">
          <b class="text-xs font-bold text-gray-500 mb-2 uppercase tracking-wider">Share with</b>

          <ng-container *ngIf="studentMentors.length > 0; else noMentorMenuTemplate">
            <div *ngFor="let mentor of studentMentors"
              class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-blue-50 transition-colors"
              (click)="selectedMentorToShare = mentor; shareScholarshipWithMentor(); shareMenu.hide()">
              <div class="flex flex-column">
                <span class="text-sm font-bold text-gray-800">{{mentor.label}}</span>
                <span class="text-xs text-gray-500">Your Mentor</span>
              </div>
            </div>
          </ng-container>

          <ng-template #noMentorMenuTemplate>
            <div
              class="flex align-items-center gap-3 p-3 border-round-lg cursor-pointer hover:bg-orange-50 transition-colors"
              (click)="navigateToMentors(); shareMenu.hide()">
              <div class="flex flex-column">
                <span class="text-sm font-bold text-gray-800">No Mentor Found</span>
                <span class="text-xs text-blue-600 font-medium">Choose your mentor</span>
              </div>
            </div>
          </ng-template>
        </div>
      </p-overlayPanel>
    </div>
  </div>
</p-dialog>

<!-- Featured Scholarships Showcase Section -->
<section class="featured-showcase-section w-full py-8 text-center relative overflow-hidden">
  
  <!-- Decorative Dot Grid (Far Left) -->
  <div class="decorative-dot-grid absolute">
    <svg viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 120px; height: 60px;">
      <pattern id="dotpattern" x="0" y="0" width="12" height="10" patternUnits="userSpaceOnUse">
        <circle cx="3" cy="3" r="1.5" fill="#cddb29" opacity="0.8" />
      </pattern>
      <rect width="100" height="50" fill="url(#dotpattern)" />
    </svg>
  </div>
  
  <div class="container_width px-4 relative z-2" style="max-width: 1250px;">
    
    <!-- Title with decorative sparkles -->
    <div class="title-container flex justify-content-center align-items-center mb-8 relative mx-auto" style="width: fit-content;">
      <!-- Sparkles asset on left of title -->
      <span class="decorative-sparkles absolute">
        <img src="assets/images/Group 43011.png" alt="Sparkles Accent">
      </span>
      <h2 class="font-bold text-5xl m-0 text-center relative" style="font-family: 'Circular Std', sans-serif; padding-left: 20px;">
        Scholarship for every student
        <div class="title-underline absolute"></div>
      </h2>
    </div>

    <!-- Cards Grid -->
    <div class="grid justify-content-center mt-5 mb-8">
      <div *ngFor="let card of featuredScholarships" class="col-12 md:col-4 p-3">
        <div class="featured-card-item p-5 border-round-3xl flex flex-column justify-content-between text-left h-full transition-all">
          <div class="flex flex-column gap-2">
            <h3 class="card-name font-bold text-2xl m-0 line-height-2" style="color: #0b117b;">{{ card.name }}</h3>
            <span class="card-uni flex align-items-center text-sm font-semibold gap-2 mt-1" style="color: rgba(11, 17, 123, 0.75);">
              <i class="pi pi-map-marker text-xs"></i> {{ card.university }}
            </span>
          </div>

          <div class="flex flex-column gap-3 mt-6">
            <span class="card-amount font-bold text-6xl" style="color: #0b117b;">{{ card.amount }}</span>
            <span class="card-deadline text-xs font-bold" style="color: rgba(11, 17, 123, 0.65);">{{ card.deadline }}</span>
            
            <button (click)="openScholarshipDetails(card)" 
               class="apply-btn text-center font-bold py-3 px-4 border-round-2xl transition-colors shadow-sm text-sm w-full cursor-pointer"
               style="display: block; background-color: #fdfdf6; color: #0b117b; border: 1px solid rgba(11, 17, 123, 0.1);">
              View Details
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Navigation Button and Arrow SVG -->
    <div class="footer-btn-container flex justify-content-center align-items-center relative mt-6 pb-4">
      
      <!-- Dotted Curved Arrow Path -->
      <div class="decorative-arrow-svg absolute">
        <img src="assets/images/Vector 381.png" alt="Decorative Arrow">
      </div>

      <button class="p-link explore-all-btn font-bold px-5 py-3 border-round-2xl transition-all shadow-3 text-md"
              (click)="navigateToAllScholarships()">
        Explore all Scholarships
      </button>
    </div>

  </div>
</section>

<!-- Strategy Call CTA Section -->
<section class="clarity-call-section w-full py-6 relative overflow-hidden" style="background-color: transparent;">
  <div class="container_width px-4 relative z-2" style="max-width: 1250px;">
    <div class="clarity-banner-container border-round-3xl shadow-3 relative overflow-hidden">
      <!-- Glow Accent (Right) -->
      <div class="glow-accent absolute"></div>

      <!-- Left Illustration -->
      <div class="illustration-col">
        <img src="assets/images/Group 716.png" 
             alt="Team building blocks illustration" 
             class="banner-illustration">
      </div>

      <!-- Middle Message -->
      <div class="text-col text-white">
        <h2 class="font-bold text-3xl md:text-4xl m-0 leading-height-2">
          Not sure which Scholarship is right <span class="neon-yellow-text">for your goals?</span>
        </h2>
        <p class="m-0 text-sm md:text-md line-height-3 text-gray-200">
          Book a call with one of our peers or your mentor so they can point you in the right direction.
        </p>
      </div>

      <!-- Right CTA Button -->
      <div class="button-col">
        <button class="p-link book-call-btn" (click)="bookClarityCall()">
          Book My Clarity Call
        </button>
      </div>
    </div>
  </div>
</section>
